/**
 * Green "Saved" chip — same visual as LienTab completion (#337).
 */
interface Props {
  testId?: string
}

export default function SavedBadge({ testId = 'inline-saved-badge' }: Props) {
  return (
    <span
      style={{
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        color: 'var(--green)',
        background: 'var(--green-l)',
        borderRadius: 6,
        padding: '3px 7px',
      }}
      data-testid={testId}
    >
      Saved
    </span>
  )
}
